module.exports = __webpack_public_path__ + "static/media/illustration-section-10.371b8609.svg";